module.exports = __webpack_public_path__ + "static/media/card-ads-mobile-es.226aa53c.png";